import { useSelector } from 'react-redux';
import { hasAccessToDocumentVaultSelector } from '../../CommonSelectors/CommonAreaSelector';

export const useHasAccessToDocumentVault = (): boolean => {
  return useSelector(hasAccessToDocumentVaultSelector);
};
